<template>
  <div class="wrapper">
    <header-bar></header-bar>
    <side-bar></side-bar>
    <div class="content-wrapper">
      <section class="content-header">
        <template v-for="alert in $store.getters.alerts">
          <b-alert :show="alert.dismiss" dismissible :variant="alert.type" @dismissed="dismissAlert(alert)">
            <h4>
              <i :class="alert.icon"></i>{{`alert_${alert.type}` | translate}}!
            </h4>
            {{alert.message}}
            <a v-if="alert.action" class="btn btn-success" @click="alert.action">Go to Details</a>
          </b-alert>
        </template>
        <template v-if="$route.path === '/directsale/gaxsys'">
          <h1 class="pageTitle">{{'directsale_gaxsys' | translate}}</h1>
        </template>
        <template v-else-if="$route.path === '/directsale/amazon'">
          <h1 class="pageTitle">{{'directsale_amazon' | translate}}</h1>
        </template>
        <template v-else-if="$route.path === '/directsale/avendu'">
          <h1 class="pageTitle">{{'directsale_avendu' | translate}}</h1>
        </template>
        <template v-else-if="$route.path === '/directsale/atalanda'">
          <h1 class="pageTitle">{{'directsale_atalanda' | translate}}</h1>
        </template>
        <template v-else-if="$route.path === '/directsale/bagmondo'">
          <h1 class="pageTitle">{{'directsale_bagmondo' | translate}}</h1>
        </template>
        <template v-else-if="$route.params.type === 'orders'">
          <h1 class="pageTitle" id="pageTitle">{{ 'open-orders' | translate }}</h1>
        </template>
        <template v-else-if="$route.params.type === 'returns'">
          <h1 class="pageTitle" id="pageTitle">{{ 'returns' | translate }}</h1>
        </template>
        <template v-else>
          <h1 class="pageTitle">{{translate($route && $route.name) || $route.name}}</h1>
        </template>
        <ol class="breadcrumb">
          <li><a href="javascript:;"><i class="fa fa-dashboard"></i>{{'home' | translate}}</a></li>
          <template v-if="$route.path !== '/home'" v-for="path in pathsGenerator()">
            <li class="active">{{translate(path) || path}}</li>
          </template>
        </ol>
      </section>
      <news></news>
      <router-view></router-view>
    </div>
    <button class="btn btn-primary btn-lg" data-toggle="modal" data-target="#error-modal"></button>
    <footer class="main-footer">
      <strong>Copyright &copy; {{year}} <a href="javascript:;">ANWR Media</a>.</strong> All rights reserved.
    </footer>
  </div>
</template>

<script>
import HeaderBar from '../tools/HeaderBar'
import SideBar from '../tools/SideBar'
require('hideseek')
export default {
  name: 'Home',
  components: {SideBar, HeaderBar},
  data () {
    return {
      labelErrors: [],
      ordersCount: 0,
      alerts: [],
      parcelOptions: '',
      stores: '',
      section: 'Dash',
      me: '',
      error: '',
      state: this.$store.state,
      translate (word) {
        let trans = this.$options.filters.translate(word, this.language)
        if (trans === 'undefined') {
          return false
        } else {
          return trans
        }
      },
      user_image: 'user2-160x160.jpg', // NEED THIS FROM DATABASE
      user_position: 'best front-end developer ever', // THIS TOO
      language: this.$store.getters.language
    }
  },
  computed: {
    classObject () {
      return 'pageLink'
    },
    year () {
      let y = new Date()
      return y.getFullYear()
    }
  },
  methods: {
    pathsGenerator () {
      let paths = this.$route.path.split('/')
      paths.shift()
      return paths
    },
    dismissAlert(alert) {
      this.$store.commit("removeAlert", alert);
    }
  },
  mounted () {
    //this.user = this.$store.getters.user
    this.$store.dispatch('checkPermissions', 'co_dashboard')

    API.get('/clickAndCollect/reservations/count')
      .then(response => {
        this.ccCount = response.data.amount
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/Home.vue